export enum SubscriptionPlan {
    STARTER = 'starter',
    /**
     * @deprecated use {@link SubscriptionPlan.STARTER} instead
     */
    FREE = 'free',
    STANDARD = 'standard',
    BUSINESS = 'business',
    ENTERPRISE = 'enterprise'
}

export enum RecurringInterval {
    MONTH = 'month',
    YEAR = 'year'
}

export const SubscriptionRecurringInterval = {
    [RecurringInterval.YEAR]: 'annuel',
    [RecurringInterval.MONTH]: 'mensuel',
}

export enum PlanType {
    ONE_TIME_COMMITMENT = 'one_time_commitment',
    RECURRING = 'recurring',
}

export enum ProductNames {
    ONE_OFFER_ONE_MONTH = 'one_offer_one_month',
    ONE_OFFER_THREE_MONTHS = 'one_offer_three_months',
    THREE_OFFER_THREE_MONTHS = 'three_offer_three_months',
    // FIVE_OFFER_FOUR_MONTHS = 'five_offer_four_months',
    PLAN_PREMIUM = 'plan_premium',
}


export const SubscriptionPlanName = {
    [SubscriptionPlan.FREE]: 'Free',
    [SubscriptionPlan.STARTER]: 'Starter',
    [SubscriptionPlan.STANDARD]: 'Standard',
    [SubscriptionPlan.BUSINESS]: 'Business',
    [SubscriptionPlan.ENTERPRISE]: 'Enterprise',

    [ProductNames.ONE_OFFER_ONE_MONTH]: "1 Offre 1 Mois",
    [ProductNames.ONE_OFFER_THREE_MONTHS]: "1 Offre 3 Mois",
    [ProductNames.THREE_OFFER_THREE_MONTHS]: "3 Offres 3 Mois",
    [ProductNames.PLAN_PREMIUM]: "Plan Premium",
}


export const isBusinessPlan = (plan: SubscriptionPlan) => {
    return plan === SubscriptionPlan.BUSINESS || plan === SubscriptionPlan.ENTERPRISE;
};

export const isBusinessOrEnterprisePlan = (plan: SubscriptionPlan) => {
    return (
        (plan ?? '').toLowerCase() === SubscriptionPlanName[SubscriptionPlan.BUSINESS].toLowerCase() ||
        (plan ?? '').toLowerCase() === SubscriptionPlanName[SubscriptionPlan.ENTERPRISE].toLowerCase()
    );
};

export const useLimitReached = (pro, recruitmentMethod?: 'premium' | 'direct_email') => {
    const classicCredits = pro?.config?.classicJobOfferQuota ?? 0;
    const premiumCredits = pro?.config?.premiumJobOfferQuota ?? 0;
    const additionalCredits = pro?.config?.additionalJobOfferQuota ?? 0;
    const totalCredits = classicCredits + premiumCredits + additionalCredits;

    const classicReachedTheLimit =
        !isBusinessPlan(pro?.stripeSubscriptionPlan) && pro?.config?.usedClassicJobOfferQuota >= classicCredits;
    const premiumReachedTheLimit =
        !isBusinessPlan(pro?.stripeSubscriptionPlan) && pro?.config?.usedPremiumJobOfferQuota >= premiumCredits;

    const totalUsedCredits = pro?.config?.usedClassicJobOfferQuota + pro?.config?.usedPremiumJobOfferQuota;
    const totalCreditsWithAdditional = totalCredits + additionalCredits;


    const isClassicAndReachedLimit =
        recruitmentMethod === 'direct_email' && classicReachedTheLimit;
    const isPremiumAndReachedLimit =
        recruitmentMethod === 'premium' && premiumReachedTheLimit;

    const stillHasAdditionalCredits = totalCredits > totalUsedCredits;
    const limitReachedBasedOnMethod =
        (isClassicAndReachedLimit || isPremiumAndReachedLimit) && !stillHasAdditionalCredits;

    return {
        classicCredits,
        premiumCredits,
        additionalCredits,
        totalCredits,
        classicReachedTheLimit,
        premiumReachedTheLimit,
        stillHasAdditionalCredits,
        totalUsedCredits,
        limitReachedBasedOnMethod,
        reachedTheLimit:
            !isBusinessPlan(pro?.stripeSubscriptionPlan) && totalUsedCredits >= totalCreditsWithAdditional,
    };
};
